import React, { useState, useEffect } from 'react';
import useLearningAssignmentToolStore from '@/stores/AdminStore/LearningAssignmentToolStore';
import CreateAssignment from './components/CreateAssignment';
import AssignmentHistory from './components/AssignmentHistory';
import './SuperAdminLearningAssignmentTool.css';

const LearningAssignmentTool: React.FC = () => {
  const {
    users,
    learningItems,
    assignments,
    userProgress,
    fetchUsers,
    fetchLearningItems,
    fetchAssignments,
    fetchUserProgress,
  } = useLearningAssignmentToolStore();

  const [activeTab, setActiveTab] = useState<'create' | 'history' | 'dynamic'>('create');

  // Lazy load data based on active tab
  useEffect(() => {
    if (activeTab === 'create' && !users) {
      fetchUsers();
    }
    if (activeTab === 'create' && !learningItems) {
      fetchLearningItems();
    }
  }, [activeTab, users, learningItems, fetchUsers, fetchLearningItems]);

  useEffect(() => {
    if (activeTab === 'history' && !assignments) {
      fetchAssignments();
    }
    if (activeTab === 'history' && !userProgress) {
      fetchUserProgress();
    }
  }, [activeTab, assignments, userProgress, fetchAssignments, fetchUserProgress]);

  return (
    <div className="s-admin-lat-container">
      <div className="s-admin-lat-breadcrumb">
        <span className="s-admin-lat-breadcrumb-item">User Management</span>
        <span className="s-admin-lat-breadcrumb-separator">›</span>
        <span className="s-admin-lat-breadcrumb-item s-admin-lat-breadcrumb-active">Learning Assignment Tool</span>
      </div>

      <div className="s-admin-lat-header">
        <h1 className="s-admin-lat-title">Learning Assignment Tool</h1>
        <p className="s-admin-lat-subtitle">Bulk-assign learning items to selected users efficiently</p>
      </div>

      <div className="s-admin-lat-tabs">
        <button
          className={`s-admin-lat-tab ${activeTab === 'create' ? 's-admin-lat-tab-active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          Create Assignment
        </button>
        <button
          className={`s-admin-lat-tab ${activeTab === 'history' ? 's-admin-lat-tab-active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Assignment History
        </button>
        <button
          className={`s-admin-lat-tab ${activeTab === 'dynamic' ? 's-admin-lat-tab-active' : ''}`}
          onClick={() => setActiveTab('dynamic')}
        >
          Dynamic Assignments
        </button>
      </div>

      <div className="s-admin-lat-content">
        {activeTab === 'create' && <CreateAssignment />}
        {activeTab === 'history' && <AssignmentHistory />}
        {activeTab === 'dynamic' && (
          <div className="s-admin-lat-placeholder">
            <p>Dynamic Assignments content coming soon...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LearningAssignmentTool;
